<template>
  <div>
    <vue-draggable-resizable
      v-if="is_active"
      :w="50"
      :x="50"
      :y="50"
      :resizable="false"
    > 

  </vue-draggable-resizable>
    <b-tabs>
      <b-tab
     
   
      >
      
        <b-card-code
          title="Drawed objets"
          class="progress-card"
          no-body
          style="border: 1px solid grey"
        >
        <div style="background-color:#22292F1A">
          <div style="margin-right:5px; text-align: right;">
            <b-button
              variant=""
              size="sm"
              class="mt-1"
              right:0
              style="width:100px; right:10px; padding:5px; margin-right: 5px;"
              @click="cancelData()"
              >
              Cancel
              </b-button>
            <b-button

          variant="primary"
          size="sm"
          class="mt-1"
          right:0
          style="width:100px; right:5px; padding:5px"
          @click="refreshPincelData()"
        >
          Refresh
        </b-button>
       

          </div>
        

        </div>
       
          <b-table
            :responsive="true"
            hover
            :fields="fields"
            :items="pincelData"
          >
         
          <template #cell(selected)="data">
            <b-form-checkbox
                v-model="data.value"
                class="custom-control-secondary"
                @change="selectPaintObjects(data.item.name, data.item.id, data.item.color)"
             
              >
           
            </b-form-checkbox>
             
            </template>
            <template #cell(color)="data">
              <div style="margin-top: 10px;">
             <h4> <input-color-picker
                  v-model="data.value"
                  @input="updateValue(data.item.id, data.value, data.item.name)"

                /> </h4>

                </div>

   
             
            </template>
            <template #cell(name)="data">
              
              <input type="text" v-model="data.value" style="border:0px;background-color: transparent;"  @input="updateValue(data.item.id, data.item.color, data.value)">
            </template>
            <template
              #cell(remove)="data" 
             
            >
          
              <div
                style="text-align: center; width:100%;cursor: pointer"
              >
                <feather-icon
                  icon="TrashIcon"
                  size="16"
                  class="close-btn delSlide"
                  @click="removeObject(data.item.id)"
                /></div>
            </template>
            <template  #cell(show_square)="data" >
              <b-form-checkbox
                v-model="data.value"
                class="custom-control-secondary"
                @change="showSquareObject(data.item.id, data.value)"
             
              >
            </b-form-checkbox>
        

            </template>
            <template  #cell(draw_inside)="data" >
              <b-form-checkbox
                v-model="data.value"
                class="custom-control-secondary"
                @change="drawInside(data.item.id, data.value)"
             
              >
            </b-form-checkbox>
       

            </template>
          </b-table>
        </b-card-code>
      </b-tab>
     
    </b-tabs>

  </div>
 
</template>
<script>
import InputColorPicker from 'vue-native-color-picker'
import Vue from 'vue'
import {
  BTabs, BTab, BTable, BCard, BFormInput, BButton, BFormCheckbox
} from 'bootstrap-vue'
import BCardCode from '@core/components/b-card-code/BCardCode.vue'
import VueDraggableResizable from 'vue-draggable-resizable'
import 'vue-draggable-resizable/dist/VueDraggableResizable.css'
import store from '@/store/index'
import axios from 'axios'
import BEditableTable from 'bootstrap-vue-editable-table'


const { url, port, auth } = store.state.appConfig.api
const headers = {
  authentication: auth,
  'Content-Type': 'application/json',
}

export default {
  components: {
    BTabs,
    BTab,
    BTable,
    BCardCode,
    BEditableTable,
    VueDraggableResizable,
    BCard,
    BFormInput,
    BButton,
    BFormCheckbox,
    InputColorPicker
  },
  props: {
    viewer_id: {
      type: Number,
      required: true,
    },
    pincelData: {
      type: Array,
      required: true,
    },
     task:{
      type: String,
      required: true
     }
  },
  data() {
    return {
      tableRefresh: 0,
      is_active: true,
      showDummy: true,
      newColumn: '',
      tabs: [],
      items: [],
      scenes: {},
      fields: [
      {
        key: 'selected', label: '', type: 'text', editable: false, sortable: true,
      },
      {
        key: 'color', label: '', type: 'text', editable: false, sortable: true,
      },
        {
        key: 'name', label: 'Name', type: 'text', editable: true, sortable: true,
      },
     
      {
        key: 'object_type', label: 'Type', type: 'text', editable: false, sortable: true,
      },
      
      {
        key: 'draw_inside', label: '', type: 'text', editable: false, sortable: true,
      },
      {
        key: 'show_square', label: '', type: 'text', editable: false, sortable: true,
      },
    
      {
        key: 'remove', label: '', type: 'text', editable: false, sortable: true,
      },
     
      ],
     
    }
  },
  computed: {

  },
  watch: {

  },
  mounted() {
  
  },
  methods: {
    cancelData(){
      this.$parent.closePincelData();
    },
    changeName(event, name, names){
      console.log("NAME CHANGE", event, name, names)
      for(var i=0;i< pincelData.length; i++){
        if(data[i].name == actual_name){
            data[i].name = objectNameEdit
            data[i].color = colorPickerEdit
        }
      }
      this.updatePaintList()
    },
    refreshPincelData(){
      this.$parent.refreshPincelData();
    },
    async removeObject(id){
      this.pincelData = this.pincelData.filter(a => a.id != id)
      console.log("We remove object with id", id)
      axios.put(`${url}:${port}/viewer-delete-object-paints/${id}`, JSON.stringify({}), { headers }).then(async response => {
        if (response) {
        
        }
      }).catch(err =>{
          console.log(err)
        })
      // axios.put(`${url}:${port}/viewer-update-paint-list/${actual_viewer_id}`, JSON.stringify(data), { headers }).then(async response => {
      //   if (response) {
      //     console.log("Updated", actual_viewer_id)
      //     document.location.reload()
  
      //   }
      // }).catch(err =>{
      //     console.log(err)
      //   })

    },
  
    async showSquareObject(id, val){
      var show_s = 0
      if(val){
        show_s = 1
      }
      console.log("Show square", id, show_s)
      await axios.put(`${url}:${port}/viewer-show-square/${id}/${show_s}`, JSON.stringify({}), { headers }).then(response => {
        if (response) {
          console.log("Response saving coo", response)
       
          return true
         
        }
      })

    },
    async drawInside(id, val){
      var show_s = 0
      if(val){
        show_s = 1
      }
      console.log("Show square", id, show_s)
      await axios.put(`${url}:${port}/viewer-draw-inside/${id}/${show_s}`, JSON.stringify({}), { headers }).then(response => {
        if (response) {
          console.log("Response saving coo", response)
       
          return true
         
        }
      })

    },
    updateValue(id, value, name){
   
      const data = {
        color: value,
        name: name
      }
       axios.put(`${url}:${port}/viewer-update-object-paints/${id}`, JSON.stringify(data), { headers }).then(async response => {
        if (response) {
        
     
  
        }
      }).catch(err =>{
          console.log(err)
        })
      
    },
   
    selectPaintObjects(name, pk, color){
      var is_selected = 0
      for(var i=0;i< this.pincelData.length; i++){
        if(this.pincelData[i].name == name){
          if(this.pincelData[i].selected){this.pincelData[i].selected = false}
          else{this.pincelData[i].selected = true; is_selected= 1}
        }
      }
      console.log("Color is", color, is_selected)
      this.updateSelectedPaints(pk, is_selected)
    },
    updateSelectedPaints(pk_object, value){
      console.log("Updating object", pk_object, value)
      axios.put(`${url}:${port}/viewer-update-selected-object/${pk_object}/${value}`, JSON.stringify({}), { headers }).then(response => {
        if (response) {
       
        }
      })

    },
   
  },
}
</script>
<style>
.vdr{
  border: unset!important;
  z-index: 1000!important;
}
.dummyCard .card-body{
  display: flex;
}
.dummyCard .card-header{
background:#b4b7bd4f;
margin-bottom: 1.5rem;
cursor: all-scroll;
}
.dummyCard .row{
  display: flex;
}
.dummyCard svg{
  cursor:pointer
}
.dummyCard svg.deactive circle{
  fill: lightgray!important;
  stroke: gray!important;;
}
.close-btn{
  margin-left:5px;
  cursor: pointer;
}
.close-btn:hover{
  margin-left:5px;
  color: #008380;
}
.editable-table .data-cell {
  padding: 0.4rem 0.4rem;
}

.editable-table th, .editable-table td {
  vertical-align: middle !important;
  /*cursor:text;*/
}

.editable-table .form-check {
  margin-left: 7px;
}
.vdr .card-header{
    display: flex;
    justify-content: flex-end;
}
.sceneTable .card-header{
    display: flex;
    justify-content: flex-end;
}
.sceneTable .card-header div{
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: center;
    align-items: flex-end;
}
.sceneTable .card-header div .btn{
    margin-left: 10px;
    /* min-width: 185px !important; */
}
th{
    width: auto;
    white-space: nowrap;
    }
/* .custom-select{
  min-width: 75px;
} */
.card .card-header .card-title {
    margin-bottom: 0;
    padding-left: 10px;
}


</style>
